import { Component, type ReactNode } from "react";
import { Button } from "@themes/pollinator/ui/Button";
import { logVideoRoomError } from "@platform/features/video/utils/logVideoRoomError";

type Props = {
  children: ReactNode;
  meetingId?: string;
};

type State = {
  hasError: boolean;
};

export class VideoMeetingErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error) {
    logVideoRoomError(error.message, "render_error", {
      stack: error.stack,
      meetingId: this.props.meetingId,
    });
  }

  handleRejoin = () => {
    const meetingId = this.props.meetingId;
    if (meetingId) {
      window.location.href = `/video/join/${meetingId}`;
    } else {
      window.location.href = "/";
    }
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex h-screen flex-col items-center justify-center gap-4 bg-gray-900 text-white">
          <h2 className="text-xl font-semibold">Something went wrong</h2>
          <p className="text-gray-400">
            An unexpected error occurred in the video meeting.
          </p>
          <Button onClick={this.handleRejoin} variant="primary">
            Rejoin Meeting
          </Button>
        </div>
      );
    }
    return this.props.children;
  }
}
